if (typeof window.themeObj === 'undefined') {
  
    window.themeObj = {
      templates: {},
      sections: {}
    };
  }
  
  window.themeObj.templates.collectionCms = {
    init: function() {
      const collectionData = document.querySelector('.collection-template-cms__data');
    
      if (collectionData) {
        var queryOptions = {
          method: 'GET',
          credentials: 'same-origin'
        };
        
        const collectionCmsQuery = collectionData.getAttribute('data-cms-query');
    
        /* Searchspring.io */
        if (/^\/collections\/.+/.test(collectionCmsQuery)) {
          
          window.themeObj.templates.collectionCms.appendProducts(1, function(response) {
            /* Total */
            window.themeObj.templates.collectionCms.total(response);
            /* /Total */
  
            /* Sorting */
            window.themeObj.templates.collectionCms.sorting(response);
            /* /Sorting */
  
            /* Active filters */
            if (response.filterSummary) {
              const activeFilters = $('.search-filter-tags');
  
              for (var i = 0; i < response.filterSummary.length; i++) {
                const activeFilterData = response.filterSummary[i];
                activeFilters.append(
                  '<span name="' + activeFilterData.field + '" value="' + activeFilterData.filterValue + '" class="filter-tag" data-option="' + activeFilterData.filterValue + '" data-facet-field="' + activeFilterData.field + '" data-filter-tag="">' +
                  '<span style="font-family: Gotham Bold, Arial, Helvetica, sans-serif;">' + activeFilterData.filterLabel + '</span>: ' + activeFilterData.filterValue +
                  '</span>'
                );
              }
  
              activeFilters.addClass('is-active');
            }
  
            $(document).on('click', '.search-filter-tags > .filter-tag', function() {
              const cmsData = $('.collection-template-cms__data');
              const cmsDataQuery = cmsData.attr('data-cms-query');
              const newCmsDataQuery = cmsDataQuery.replace(/\?.+$/, '');
              const cmsDataQueryHost = cmsData.attr('data-cms-query-host');
              
              window.location.href = '//' + cmsDataQueryHost + newCmsDataQuery;
            });
  
            $(document).on('click', '.c-collection-template__filters-clear-button--desktop', function() {
              const filter = $(this);
              const filterUrlPart = '&filter.' + filter.attr('data-facet-field') + '=' + filter.attr('data-option');
  
              const cmsData = $('.collection-template-cms__data');
              const cmsDataQuery = cmsData.attr('data-cms-query');
              const newCmsDataQuery = cmsDataQuery.replace(filterUrlPart, '').replace(/\?.*$/, '');
              const cmsDataQueryHost = cmsData.attr('data-cms-query-host');
              
              window.location.href = '//' + cmsDataQueryHost + newCmsDataQuery;
            });
            /* /Active filters */
  
            /* Filters */
            if (response.facets) {
              const filters = $('.c-collection-faceted-nav');
  
              if (filters.length) {
                
                for (var i = 0; i < response.facets.length; i++) {
                  const filterData = response.facets[i];
  
                  const filter = $(
                    '<div class="c-collection-faceted-nav__group is-type has-options" data-faceted-nav-group="" data-faceted-nav-types="" data-faceted-nav-single-filter="' + filterData.field + '">' +
                      '<span class="c-collection-faceted-nav__title' + (filterData.facet_active ? ' is-active' : '') + '">' + filterData.label + (filterData.facet_active ? ' (' + filterData.facet_active + ')' : '') + '</span>' +
                      '<button class="c-collection-template__filter-clear-button is-mobile" data-filter-category-clear="" data-filter-category-clear-mobile="">Clear</button>' +
                      '<div class="c-collection-faceted-nav__check-group-wrapper is-hidden" data-check-group-wrapper="">' +
                        '<ul class="c-collection-faceted-nav__check-group" data-faceted-check-group=""></ul>' +
                        '<div class="c-collection-template__filter-button-wrapper">' +
                          '<button class="c-collection-template__filter-clear-button is-desktop" data-filter-category-clear="" data-filter-category-clear-desktop="">Clear</button>' +
                          '<button class="c-collection-template__filter-close-button is-desktop" data-filter-category-close="">Close</button>' +
                          '</div>' +
                      '</div>' +
                    '</div>'
                  );
  
                  const filterValues = filter.find('.c-collection-faceted-nav__check-group');
  
                  for (var i2 = 0; i2 < filterData.values.length; i2++) {
                    const filterOptionData = filterData.values[i2];
                    filterValues.append(
                      '<li class="c-collection-faceted-nav__check-item">' +
                        '<div class="o-checkbox">' +
                          '<input type="checkbox" class="o-checkbox__checkbox" data-index="0" data-option="' + filterOptionData.label + '" data-facet-field="' + filterData.field + '" data-facet-checkbox=""' + (filterOptionData.active ? ' checked' : '') + '>' +
                          '<label class="o-checkbox__label">' + filterOptionData.label + ' (' + filterOptionData.count + ')</label>' +
                        '</div>' +
                      '</li>'
                    );
                  }
  
                  filters.append(filter);
                }
                
                $(document).on('click', '.c-collection-faceted-nav__title', function() {
                  const filterTitle = $(this);
                  
                  const filter = filterTitle.parents('.c-collection-faceted-nav__group');
                  filter.toggleClass('is-expanded').siblings('.is-expanded').removeClass('is-expanded');
  
                  const filterDropdown = filter.find('.c-collection-faceted-nav__check-group-wrapper');
  
                  if (filter.hasClass('is-expanded')) {
                    filterDropdown.removeClass('is-hidden');
                  
                  } else {
                    filterDropdown.addClass('is-hidden');
                  }
                });
                
                $(document).on('click', '.c-collection-template__filter-clear-button.is-desktop', function() {
                  const clearButton = $(this);
                  const filter = clearButton.parents('.c-collection-faceted-nav__group');
                  
                  const activeFilterOptions = filter.find('.o-checkbox__checkbox:checked');
  
                  if (activeFilterOptions.length) {
                    const cmsData = $('.collection-template-cms__data');
                    const cmsDataQuery = cmsData.attr('data-cms-query');
                    const cmsDataQueryHost = cmsData.attr('data-cms-query-host');
  
                    var newCmsDataQuery = cmsDataQuery;
                    
                    activeFilterOptions.each(function() {
                      const activeFilterOption = $(this);
                      const activeFilterUrlPart = '&filter.' + activeFilterOption.attr('data-facet-field') + '=' + activeFilterOption.attr('data-option');
  
                      newCmsDataQuery = newCmsDataQuery.replace(activeFilterUrlPart, '');
                    });
                    
                    window.location.href = '//' + cmsDataQueryHost + newCmsDataQuery;
                  }
  
                  filter.removeClass('is-expanded');
                });
                
                $(document).on('click', '.c-collection-template__filter-close-button.is-desktop', function() {
                  const closeButton = $(this);
                  
                  const filter = closeButton.parents('.c-collection-faceted-nav__group');
                  filter.removeClass('is-expanded');
                });
              }
            }
  
            $(document).on('click', '.c-collection-template__filters-toggle-button', function() {
              $('.c-collection-faceted-nav').addClass('is-filters-toggled');
            });
  
            $('.c-search-filter__container').on('click', '.c-collection-faceted-nav__close', function() {
              $('.c-collection-faceted-nav').removeClass('is-filters-toggled');
            });
            /* /Filters */
  
            /* Filters options */
            $('.c-search-filter__container').on('click', '.c-collection-faceted-nav__check-item', function() {
              const filterOption = $(this);
              const filterOptionCheckbox = filterOption.find('.o-checkbox__checkbox');
              const filterOptionUrlPart = '&filter.' + filterOptionCheckbox.attr('data-facet-field') + '=' + filterOptionCheckbox.attr('data-option');
              
              const cmsData = $('.collection-template-cms__data');
              const cmsDataQuery = cmsData.attr('data-cms-query');
              const cmsDataQueryHost = cmsData.attr('data-cms-query-host');
              
              window.location.href = '//' + cmsDataQueryHost + cmsDataQuery + filterOptionUrlPart;
            });
            /* /Filters options */
            
            const contentMain = $('.c-collection-template__content-main');
            contentMain.hide();
            
            const content = $('.c-collection-template__content');
            content.show();
          });
      
          /* Load more */
          window.themeObj.templates.collectionCms.pagination();
          /* /Load more */
    
        /* /Searchspring.io */
        } else {
          const queries = [
            fetch(collectionData.getAttribute('data-cms-query'), queryOptions)
          ];
          
          Promise.all(queries).then(function (responses) {
        
            Promise.all(responses.map(function (response) {
              return response.text();
      
            })).then(function (contents) {
              const products = document.querySelector('.c-collection-template__content');
        
              const content = document.createElement('div');
              content.innerHTML = contents[0].trim();
              content.removeAttribute('style');
              
              const contentProducts = content.querySelector('.c-collection-template__content');
        
              if (products && contentProducts) {
                products.innerHTML = contentProducts.innerHTML;
      
                const currentPage = products.querySelector('.o-pagination > .current');
                const nextPageLink = products.querySelector('.o-pagination > .next > a');
      
                if (currentPage && nextPageLink) {
                  const currentPageValue = parseInt(currentPage.innerHTML.trim());
                  const nextPageLinkURL = collectionCmsQuery + '&page=' + (currentPageValue + 1);
                  nextPageLink.setAttribute('href', nextPageLinkURL);
                }
                
                const pageLinks = products.querySelectorAll('.o-pagination > .page > a');
      
                if (pageLinks) {
                  
                  for (var i = 0; i < pageLinks.length; i++) {
                    const pageLink = pageLinks[i];
                    const pageLinkURL = collectionCmsQuery + '&page=' + pageLink.innerHTML.trim();
                    pageLink.setAttribute('href', pageLinkURL);
                  }
                }
              }
            });
          });
        }
      }
    },
    total: function(response) {
      const productsCount = $('.c-collection-template__filters-count-container');
      productsCount.find('p > span').text(response.pagination.totalResults);
      productsCount.show();
    },
    sorting: function(response) {
      const sortingSelector = $('.c-collection-template__sort-select');
  
      for (var i = 0; i < response.sorting.options.length; i++) {
        const sortingOption = response.sorting.options[i];
        sortingSelector.append(
          '<option value="' + sortingOption.field + '" data-searchspring-direction="' + sortingOption.direction + '">' + sortingOption.label + '</option>'
        );
      }
  
      $(document).on('change', '.c-collection-template__sort-select', function() {
        const selector = $(this);
        const selectorValue = selector.val();
        const activeOption = selector.children('option[value="' + selectorValue + '"]');
  
        const cmsData = $('.collection-template-cms__data');
        const cmsDataQuery = cmsData.attr('data-cms-query');
        const newCmsDataQuery = cmsDataQuery + '&sort.' + selectorValue + '=' + selector.children('option[value="' + selectorValue + '"]').attr('data-searchspring-direction');
        const cmsDataQueryHost = cmsData.attr('data-cms-query-host');
        
        window.location.href = '//' + cmsDataQueryHost + newCmsDataQuery;
      });
    },
    pagination: function(response) {
      $(document).on('click', '.c-collection-template__load-more', function() {
        const btn = $(this);
        btn.prop('disabled', true);
        
        window.themeObj.templates.collectionCms.appendProducts(2, function() {
          btn.prop('disabled', true);
        });
      });
    },
    getSearchspringUrl: function(page) {
      const collectionData = document.querySelector('.collection-template-cms__data');
      const collectionCmsQuery = collectionData.getAttribute('data-cms-query');
      const productsPerPage = $('.c-collection-template').attr('data-collection-per-page');
      
      var urlPart = collectionCmsQuery.replace(/^.+\?/, '');
      var url = 
        'https://rtfv07.a.searchspring.io/api/search/search.json?' + 
        urlPart +
        '&page=' + page + '&settings%5Bpage%5D=1&siteId=rtfv07&resultsFormat=native&resultsPerPage=' + productsPerPage + '&redirectResponse=full';
  
      return url;
    },
    appendProducts: function(page, callback) {
      const url = window.themeObj.templates.collectionCms.getSearchspringUrl(page);
      console.log('url', url);
      $.ajax({
        type: 'GET', 
        url: url,
        dataType: 'json',
        success: function (response) {
          callback(response);
          
          if (response.results) {
            /* Products */
            const products = $('.c-collection-template__products');
  
            if (page < 2) {
              products.html('');
            }
            
            for (var i = 0; i < response.results.length; i++) {
              const productGrid = response.results[i];
  
              var productGridImage = productGrid.ss_image;
              var productGridImageHover = productGrid.ss_image_hover;
  
              const productGridSwatches = JSON.parse(window.themeObj.tools.htmlDecode(productGrid.ss_swatches));
              
              if (productGridSwatches) {
                var productGridActiveColorI = 0;
  
                if (url.includes('mfield_custom_top_level_colour')) {
                  var filterColor = url.replace(/^.*mfield\_custom\_top\_level\_colour\=([0-9A-z\-\_]+).*$/, '$1');
  
                  if (productGrid.mfield_custom_top_level_colour) {
                    
                    for (var i2 = 0; i2 < productGrid.mfield_custom_top_level_colour.length; i2++) {
                      const productGridColor = productGrid.mfield_custom_top_level_colour[i2];
    
                      if (productGridColor == filterColor) {
                        productGridActiveColorI = i2;
                      }
                    }
                  }
                  
                  var productGridColours = 0;
                  
                  if (productGrid.tags) {
    
                    for (var i2 = 0; i2 < productGrid.tags.length; i2++) {
                      const productGridTag = productGrid.tags[i2];
    
                      if (productGridTag.includes('BaseColour_')) {
                        const productColor = productGridTag.trim().replace(/^BaseColour\_([A-z0-9]+).*$/i, '$1');
  
                        if (filterColor.includes(productColor) && productColor == filterColor.replace(/S$/, '')) {
                          productGridActiveColorI = productGridColours;
                        }
                        
                        productGridColours++;
                      }
                    }
                  }
                  
                  for (var i2 = 0; i2 < productGridSwatches.length; i2++) {
                    const productGridSwatch = productGridSwatches[i2];
    
                    if (filterColor.replace(/S$/, '') == productGridSwatch.colour) {
                      productGridActiveColorI = i2;
                    }
                  }
                }
  
                const productGridActiveSwatch = productGridSwatches[productGridActiveColorI];
  
                productGridImage = productGridActiveSwatch.image;
  
                if (/\_grande\.(jpg|jpeg|png|webp)\?v\=([0-9]+)$/.test(productGridImage)) {
                  productGridImage = productGridImage.replace(/\_grande\.(jpg|jpeg|png|webp)\?v\=([0-9]+)$/, '_600x.$1?v=$2');
                }
                
                productGridImageHover = productGridActiveSwatch.alt;
  
                if (/\.(jpg|jpeg|png|webp)\?v\=([0-9]+)$/.test(productGridImageHover)) {
                  productGridImageHover = productGridImageHover.replace(/\.(jpg|jpeg|png|webp)\?v\=([0-9]+)$/, '_600x.$1?v=$2');
                }
              }
  
              var productGridHtml = 
              '<div class="o-product-thumbnail--featured c-collection-template__product">' +
              '<div class="o-product-thumbnail--featured__container">' +
              '<div class="o-product-thumbnail--featured__details--wrapper" data-product-content="">' +
  
              '<div class="image-wrapper">' +
                '<a href="' + productGrid.url + '" class="o-product-thumbnail--featured__image-container has-secondary-thumbnail">' +
                  '<picture>' +
                    '<source media="(min-width:600px)" srcset="' + productGridImage + ', ' + productGridImage.replace(/\_600x(600|)\./, '_1200x.') + ' 2x, ' + productGridImage.replace(/\_600x(600|)\./, '_2400x.') + ' 4x" data-sizes="auto" alt="' + productGrid.name + '">' +
                    '<img src="' + productGridImage + '" width="800" alt="' + productGrid.name + '" class="o-product-thumbnail--featured__image__img thumbnail-primary">' +
                  '</picture>' +
                  '<picture>' +
                    '<source media="(min-width:600px)" srcset="' + productGridImageHover + ', ' + productGridImageHover.replace(/\_600x(600|)\./, '_1200x.') + ' 2x, ' + productGridImageHover.replace(/\_600x(600|)\./, '_2400x.') + ' 4x" data-sizes="auto" alt="' + productGrid.name + '">' +
                    '<img src="' + productGridImageHover + '" width="800" alt="' + productGrid.name + '" class="o-product-thumbnail--featured__image__img thumbnail-secondary">' +
                  '</picture>' +
                '</a>' +
              '</div>';
  
              productGridHtml += 
              '<div class="badges">';
              
              for (var i2 = 0; i2 < productGrid.ss_tags.length; i2++) {
                productGridHtml +=
                '<span class="o-badge--' + productGrid.ss_tags[i2].replace(/\%/, '') + ' o-badge"></span>';
              }
              productGridHtml +=
              '</div>';
    
              productGridHtml +=
                    '<div class="o-product-thumbnail--featured__details">' +
                      '<div class="o-product-thumbnail--featured__details-left">' +
                        '<a href="' + productGrid.url + '" class="o-product-thumbnail--featured__details-link">' +
                          '<h4 class="o-product-thumbnail--featured__title ">' + productGrid.name + '</h4>' +
                        '</a>' +
                        '<div>' +
                          '<div class="o-product-pricing o-product-thumbnail--featured__price' + (parseFloat(productGrid.variant_compare_at_price) > parseFloat(productGrid.variant_price) ? ' has-compare-price' : '') + '">' +
                            (parseFloat(productGrid.variant_compare_at_price) > parseFloat(productGrid.variant_price) ? '<div class="o-product-pricing__money o-product-pricing__price o-product-thumbnail--featured__price-money o-product-thumbnail--featured__price-price old-price">$' + productGrid.variant_compare_at_price + '</div>': '') +
                            '<div class="o-product-pricing__money o-product-pricing__price o-product-thumbnail--featured__price-money o-product-thumbnail--featured__price-price  on-sale">&nbsp;$' + productGrid.variant_price.replace(/\|.*$/, '') + '</div>' +
                            '</div>' +
                          '</div>' +
                        '</div>';
              
              if (productGridSwatches) {
                productGridHtml +=
                        '<div class="o-swatches o-product-thumbnail--featured">' +
                          '<div class=" o-swatches__swatch has-js is-color">' +
                            '<div class="o-swatches__swatch-options">';
  
                for (var i2 = 0; i2 < productGridSwatches.length; i2++) {
                  const productGridSwatch = productGridSwatches[i2];
                  productGridHtml +=
                              '<a href="' + productGridSwatch.url + '" class="o-swatches__swatch-option s-swatch--' + productGridSwatch.colour.replace(/(\/|\s)/, '-').toLowerCase() + '' + (productGridSwatch.available ? ' is-visible' : '') + '' + (productGridActiveColorI == i2 ? ' is-selected' : '') + '" title="' + productGridSwatch.colour + '"></a>';
                }
                
                productGridHtml +=
                            '</div>' +
                          '</div>' +
                        '</div>';
              }
  
              productGridHtml +=
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>'
              
              products.append(productGridHtml);
            }
            /* /Products */
            
            /* Load more */
            const loadMoreWrapper = $('.c-collection-template__load-more-container');
            const loadMore = $('.c-collection-template__load-more');
  
            if (response.pagination.currentPage == response.pagination.totalPages) {
              loadMoreWrapper.remove();
            
            } else {
              loadMoreWrapper.show();
            }
            /* /Load more */
          }
        }
      });
    }
  };
  
  window.themeObj.tools = {
    htmlDecode: function(input) {
      const doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    }
  };
  
  if (document.body.classList.contains('c-page--collection') && document.querySelector('.collection-template-cms__data')) {
    window.themeObj.templates.collectionCms.init();
  }